
export const createPersonData = (key) => ({
  key,
  elementList: [
    {
      key: "sex",
      labelName: "性别",
      value: 1,
      required: true,
      componentName: "cmCommonRadioBtn",
      options: [
        { value: 1, name: "男" },
        { value: 2, name: "女" },
      ],
    },
    {
      key: "age",
      labelName: "年龄",
      value: 30,
      required: true,
      componentName: "cmAgeBirthday",
      options: new Array(106)
        .fill()
        .map((e, i) => ({ value: i, name: `${i}岁` })),
    },
    {
      key: "birthday",
      value: null,
      required: true,
    },
  ],
});
export const createDefaultCompareCase = (data) => {
  const _data = {
    insureData: null,
    resultData: null,
    interestDetailData: null,
  };
  if (data) {
    for (const k in data) {
      _data[k] = data[k];
    }
  }
  return _data;
};


export const createdTableSettingMap = (map) => {
  let list = []
  if (map) {
    const _types = Object.keys(map).filter(t => t !== 'core')
    list = _types.reduce((arr, t) => {
      const _keys = map[t] || []
      return arr.concat(_keys.map(k => ({
        type: t,
        key: k,
        display: 1,
        isHide: k === 'total_death_value' ? 1 : 0
      })))
    }, [{
      type: null,
      key: 'core',
      display: 1,
      isHide: 0
    }])
    const _list = localStorage.getItem('compare3TableSettingList') ? JSON.parse(localStorage.getItem('compare3TableSettingList')) : []
    _list.forEach(_e => {
      list.forEach(e => {
        if (e.type === _e.type && e.key === _e.key) {
          e.display = _e.display
        }
      })
    })
  }
  return list
}

export const DEFAULT_INTEREST_KEY_MAP = {
  low: ['total_cash_value','total_value'],
  div: [],
  mid: ['total_cash_value','total_value', 'irr_value'],
  core: [ 'irr_value_year', 'single_value_year', 'back_year'],
}

export const DEFAULT_MODULENAME=['case','baof','baoe','bonus','company','reduce','tax','feature','clause','businessCard']